var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"error-area"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-6 soon-top"},[_c('div',{staticClass:"error-content text-center"},[_c('h3',{staticClass:"title soon-font"},[_vm._v(_vm._s(_vm.$t("Under Renovation")))])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }